import { updateQuery, useQueryParam, useRouter } from '@mi-front/core';
import { TabContext, TabPanel } from '@mui/lab';
import { Box, Tab, Tabs } from '@mui/material';
import React from 'react';

type TabItem = {
  value: string;
  label: React.ReactNode;
  content: React.ReactNode;
};

type Props = {
  id: string;
  param?: string;
  tabs: TabItem[];
  tabPaddingTop?: number;
};

const DEFAULT_PARAM = 'tab';

export function ParamDrivenTabsMui(p: Props) {
  const { tabs, param, tabPaddingTop = 2, ...rest } = p;
  const targetParam = param || DEFAULT_PARAM;

  const tabKeys = tabs.map((tab) => tab.value);

  const { history } = useRouter();
  const tab = useQueryParam(targetParam);
  const activeTab = tabKeys.includes(tab) ? tab : tabKeys[0];

  const handleChange = (_: React.SyntheticEvent, newValue: string) => {
    updateQuery(history, {
      [targetParam]: newValue,
    });
  };

  return (
    <Box sx={{ width: '100%' }}>
      <TabContext value={activeTab}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={activeTab} onChange={handleChange} aria-label={`${p.id}-tabs`} {...rest}>
            {tabs.map((tab) => (
              <Tab key={tab.value} value={tab.value} label={tab.label} />
            ))}
          </Tabs>
        </Box>
        {tabs.map((tab) => (
          <TabPanel key={tab.value} value={tab.value} sx={{ p: 0, pt: tabPaddingTop }}>
            {tab.content}
          </TabPanel>
        ))}
      </TabContext>
    </Box>
  );
}
